import React from "react";
import { Props } from "./types";

function EnterIcon({ className }: Props) {
  return (
    <svg className={className} viewBox="0 0 17.151 14.693">
      <path
        d="M15.007,7.146V0h2.144V7.772A1.519,1.519,0,0,1,15.633,9.29H3.659l3.888,3.888L6.03,14.693.313,8.976a1.072,1.072,0,0,1,0-1.515L6.03,1.744,7.545,3.259,3.659,7.146Z"
        fill="#fff"
        fillRule="evenodd"
      />
    </svg>
  );
}

export { EnterIcon };
